/**
 * Created by strunz on 23.05.2017.
 */


import {Pipe} from '@angular/core';

@Pipe({
    name: 'productTeaserName'
})
export class ProductTeaserNamePipe {
    transform(productTeaserName: string): string {
        return productTeaserName.split(';').join('\n');
    }
}